import React, { Component } from "react";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Cookies from "js-cookie";
import Typography from "@mui/material/Typography";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import axios from "axios";
import settings from "../helpers/Settings";
import * as moment from "moment";
import { CSVLink } from "react-csv";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Checkbox from "@mui/material/Checkbox";
let { KayanURL } = settings;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const allTPA = {
  7001463160: "GlobeMed Saudi",
  7001580856: "Nextcare",
  7001604342: "Mednet",
  7001599658: "Totalcare"
}
const totalCareInsurance = [
  { value: "7001527816", name: "Arabian Shield Cooperative Insurance Company *" },
  { vaue: "7001535694", name: "Allied Cooperative Insurance Group (ACIG)" },
  { value: "7001544472", name: "Al Sagr Cooperative Insurance Company *" },
  { value: "7001549059", name: "Trade Union Cooperative Insurance Company *" },
  { value: "7001559389", name: "United Cooperative Insurance Company" },
  { value: "7001617724", name: "Buruj Cooperative Insurance Company *" },
  { value: "7001641419", name: "Gulf General Company for Cooperative Insurance" },
  { value: "7001727200", name: "Tokyo Marine Development Corporation" }
]
const netxCareInsurance = [
  { value: "7001526578", name: "Saudi United Cooperative Insurance Company (Wala)" },
  { value: "7001537161", name: "Allianz Saudi Fransi Cooperative Insurance Company" },
  { value: "7001544472", name: "Al Sagr Cooperative Insurance Company *" },
]
const medNetInsurance = [
  { value: "7001526578", name: "Saudi United Cooperative Insurance Company (Wala)" },
  { value: "7001641419", name: "Gulf General Company for Cooperative Insurance" }
]
const globMedInsurance = [
  { value: "7001523724", name: "Salama Cooperative Insurance Company" },
  { value: "7001527667", name: "Arabia Insurance Cooperative Company" },
  { value: "7001625891", name: "Solidarity Saudi Takaful Company" },
  { value: "7001626717", name: "Amana Cooperative Insurance Company *" },
  { value: "7001703672", name: "Saudi Enaya Cooperative Insurance Company" }
]
const allInsuraceCompanies = {
  "INS-FHIR": "Pseudo Payer",
  7001527816: "Arabian Shield Cooperative Insurance Company *",
  7001571327: "Bupa Arabia for Cooperative Insurance",
  7000911508: "The Cooperative Company for Cooperative Insurance",
  7001593321: "Al-Rajhi Company for Cooperative Insurance",
  7001548317: "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)",
  7001539720: "Saudi Arabian Cooperative Insurance Company (SAICO) *",
  7001532279: "Gulf Union Cooperative Insurance Company",
  7001607683: "AXA Cooperative Insurance Company",
  7001519912: "Malath Cooperative Insurance and Reinsurance Company",
  7001559389: "United Cooperative Insurance Company",
  7001727200: "Tokyo Marine Development Corporation",
  7001617724: "Buruj Cooperative Insurance Company *",
  7001549059: "Trade Union Cooperative Insurance Company *",
  7001544472: "Al Sagr Cooperative Insurance Company *",
  7001641419: "Gulf General Company for Cooperative Insurance",
  7001609481: "Global Company for Cooperative Insurance",
  7001535694: "Allied Cooperative Insurance Group (ACIG)",
  7001526578: "Saudi United Cooperative Insurance Company (Wala)",
  7001537161: "Allianz Saudi Fransi Cooperative Insurance Company",
  7001534275: "The National Company for Cooperative Insurance",
  7001626717: "Amana Cooperative Insurance Company *",
  7001625891: "Solidarity Saudi Takaful Company",
  7001703672: "Saudi Enaya Cooperative Insurance Company",
  7001523724: "Salama Cooperative Insurance Company",
  7001527667: "Arabia Insurance Cooperative Company",
};
const nonTpa = [
  { value: "INS-FHIR", name: "Pseudo Payer" },
  { value: "7001571327", name: "Bupa Arabia for Cooperative Insurance" },
  { value: "7000911508", name: "The Cooperative Company for Cooperative Insurance" },
  { value: "7001593321", name: "Al-Rajhi Company for Cooperative Insurance" },
  { value: "7001548317", name: "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)" },
  { value: "7001539720", name: "Saudi Arabian Cooperative Insurance Company (SAICO) *" },
  { value: "7001532279", name: "Gulf Union Cooperative Insurance Company" },
  { value: "7001607683", name: "AXA Cooperative Insurance Company" },
  { vaue: "7001519912", name: "Malath Cooperative Insurance and Reinsurance Company" },
  { value: "7001609481", name: "Global Company for Cooperative Insurance" },
  { value: "7001534275", name: "The National Company for Cooperative Insurance" },
]
class VisitRegisteration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferValue: false,
      newbornValue: false,
      visit: { patientId: this.props.patientIDselected, visitStatus: "1" },
      purpose: ["discovery", "benefits"],
      insuranceInfo: [],
      payment: ""
    };
  }

  componentDidMount = async () => {
    let currentdate = new Date();
    let date = moment(currentdate).format("YYYY-MM-DD");
    let nphiesID = localStorage.getItem("nphies-id");
    this.setState({ visitDate: date, nphiesID });
    this.getAllDoctors();
    this.getAllPatients();
  };
  handleSave = async (e) => {
    e.preventDefault();
    let { checkEligibilityInfo } = this.state;
    if (this.state.insuranceInfo && this.state.insuranceInfo.length == 0) {
      this.setState({ insuranceMsg: "No Policy Selected!" });
    } else if (this.state.insuranceInfo.length > 0) {
      checkEligibilityInfo.selectedInsurance = this.state.insuranceInfo;
      this.setState({
        checkEligibilityInfo,
        checkModal: false,
        insuranceMsg: "",
        errorMsg: "",
      });
    }
  };
  handleCheckEligibility = async (e) => {
    e.preventDefault();
    let { startDate, endDate, nphiesID } = this.state;

    let patient;
    let selectedPatient = this.state.allPatients.filter((p) => {
      return p.id == this.props.patientIDselected;
    });
    if (selectedPatient && selectedPatient.length > 0) {
      patient = {
        firstName: selectedPatient[0].firstname,
        lastName: selectedPatient[0].lastname,
        ID: selectedPatient[0].identifier,
        gender: selectedPatient[0].gender,
        birthDate: selectedPatient[0].birthdate,
        phone: selectedPatient[0].phone,
        identifierType: selectedPatient[0].identifiertype,
        maritalStatus: "U",
        occupation: "business"
      };
    }
    this.setState({ EligibilityRequestSent: true, EligibilityResponse: false, EligibilityError: "" });

    let CheckEligibilityResponse = await axios.post(
      KayanURL+"api/KSA/RCM/request",

      {
        apiToken: "token",
        requestType: "1",
        payerID: this.state.payerID ? this.state.payerID : "",
        TPA: this.state.TPA && this.state.TPA !== "0" ? this.state.TPA : "",
        payerName: this.state.payerName ? this.state.payerName : "",
        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        providerType: 1,
        servicedPeriod: {
          start: this.state.visitDate,
          end: this.state.visitDate,
        },
        patient: patient,
        purpose: this.state.purpose,
        coverage: this.state.coverageInfo,
        transfer: this.state.transferValue,
        testing: nphiesID === "10000300178702" ? true : false
      }
    );

    if (CheckEligibilityResponse) {
      this.setState({
        EligibilityRequestSent: false,
        EligibilityResponse: true,
      });
      let { data } = CheckEligibilityResponse;
      console.log(data);
      if (data) {
        let {
          success,
          response,
          error,
          BundleID,
          EligibilityResponseIdentifier,
          siteEligibility,
          errorNaphis,
        } = data;
        if (BundleID) {
          this.setState({ BundleID, response });
        }
        if (success) {

          let res = JSON.parse(response);
          this.setState({ res, siteEligibility, errorNaphis });
          if (!errorNaphis) {
            this.setState({
              eligibleInfoView: true,
              EligibilityResponseIdentifier,
            });
            if (res) {
              let { entry } = res;
              let insurance = [];
              if (entry && entry.length > 0) {
                let coverageEligibilityResponse = entry.filter((element) => {
                  return (
                    element["resource"]["resourceType"] ==
                    "CoverageEligibilityResponse"
                  );
                });
                coverageEligibilityResponse = coverageEligibilityResponse[0];
                let outcome =
                  coverageEligibilityResponse["resource"]["outcome"];
                siteEligibility =
                  coverageEligibilityResponse["resource"]["extension"][0][
                  "valueCodeableConcept"
                  ]["coding"][0]["code"];
                EligibilityResponseIdentifier =
                  coverageEligibilityResponse["resource"]["identifier"][0][
                  "system"
                  ] +
                  "/" +
                  coverageEligibilityResponse["resource"]["identifier"][0][
                  "value"
                  ];
                let insuranceInfo =
                  coverageEligibilityResponse["resource"]["insurance"];
                console.log(insuranceInfo)
                if (insuranceInfo && insuranceInfo.length > 0) {
                  for (let i = 0; i < insuranceInfo.length; i++) {
                    let item = insuranceInfo[i].item;
                    let coverageReference =
                      insuranceInfo[i]["coverage"]["reference"];
                    let items = [];
                    let coverage = [];
                    let insuranceSiteEligibility = insuranceInfo[i]["extension"]
                      ? insuranceInfo[i]["extension"][0]["valueCodeableConcept"][
                      "coding"
                      ][0]["code"]
                      : "";
                    // if(insuranceInfo[i]["extension"] && insuranceInfo[i]["extension"].length>0){
                    //   siteEligibility =
                    //   insuranceInfo[i]["extension"][0]["valueCodeableConcept"][
                    //     "coding"
                    //   ][0]["code"];
                    // }

                    if (item && item.length > 0) {
                      for (let i = 0; i < item.length; i++) {
                        let money, currency, allowedMoney, typeOfBenefit;
                        let benefits = item[i].benefit;
                        if (benefits && benefits.length > 0) {
                          for (let j = 0; j < benefits.length; j++) {
                            typeOfBenefit = benefits[j].type.coding[0].code ? benefits[j].type.coding[0].code : "";
                            if (benefits[j].allowedMoney) {
                              money = benefits[j].allowedMoney.value;
                              currency = benefits[j].allowedMoney.currency;
                              allowedMoney = money + currency;
                            } else if (benefits[j].allowedString) {
                              allowedMoney = benefits[j].allowedString
                            } else if (benefits[j].allowedUnsignedInt) {
                              allowedMoney = benefits[j].allowedUnsignedInt
                            } else {
                              allowedMoney = "";
                            }

                            items.push({
                              benefitType: typeOfBenefit,
                              allowedMoney: allowedMoney,
                              category: item[i].category.coding[0].code,
                              description: item[i].description,
                              name: item[i].name,
                              network: item[i].network.coding[0].code,
                              term: item[i].term.coding[0].code,
                              unit: item[i].unit.coding[0].code,
                            });
                          }
                        } else {
                          items.push({
                            benefitType: "",
                            allowedMoney: "",
                            category: item[i].category.coding[0].code,
                            description: item[i].description,
                            name: item[i].name,
                            network: item[i].network.coding[0].code,
                            term: item[i].term.coding[0].code,
                            unit: item[i].unit.coding[0].code,
                          });
                        }
                      }
                      // }
                    }
                    let coverageResource = entry.filter((resources) => {
                      return resources.fullUrl == coverageReference;
                    });
                    if (coverageResource && coverageResource.length > 0) {
                      coverageResource = coverageResource[0];
                      let period
                      if (coverageResource["resource"]["period"]) {
                        period = {
                          start: coverageResource["resource"]["period"].start,
                          end: coverageResource["resource"]["period"].end,
                        };
                      }

                      let memberid =
                        coverageResource["resource"]["identifier"][0]["value"];
                      let network = coverageResource["resource"]["network"];
                      let coverageClass = coverageResource["resource"]["class"];
                      let Class = [],
                        paymentDetails = [];
                      if (coverageClass && coverageClass.length > 0) {
                        coverageClass.forEach((element) => {
                          Class.push({
                            type: element["type"]["coding"][0]["code"],
                            name: element["type"]["coding"][0]["code"],
                            value: element["value"],
                          });
                        });
                      }
                      let costToBeneficiary =
                        coverageResource["resource"]["costToBeneficiary"];
                      if (costToBeneficiary && costToBeneficiary.length > 0) {
                        for (let i = 0; i < costToBeneficiary.length; i++) {
                          let code =
                            costToBeneficiary[i]["type"]["coding"][0]["code"];
                          if (costToBeneficiary[i]["valueQuantity"]) {
                            if (costToBeneficiary[i]["valueQuantity"]["code"]) {
                              paymentDetails.push({
                                [code]:
                                  costToBeneficiary[i]["valueQuantity"][
                                  "value"
                                  ] +
                                  " " +
                                  costToBeneficiary[i]["valueQuantity"]["code"],
                              });
                            } else {
                              paymentDetails.push({
                                [code]:
                                  costToBeneficiary[i]["valueQuantity"][
                                  "value"
                                  ],
                              });
                            }
                          } else {
                            if (
                              costToBeneficiary[i]["valueMoney"]["currency"]
                            ) {
                              let valueMoney =
                                costToBeneficiary[i]["valueMoney"]["value"] +
                                " " +
                                costToBeneficiary[i]["valueMoney"]["currency"];
                              paymentDetails.push({ [code]: valueMoney });
                            } else {
                              let valueMoney =
                                costToBeneficiary[i]["valueMoney"]["value"];
                              paymentDetails.push({ [code]: valueMoney });
                            }
                          }
                        }
                      }
                      coverage.push({
                        period,
                        memberid,
                        network,
                        "subscriber-relationship":
                          coverageResource["resource"]["relationship"][
                          "coding"
                          ][0]["code"],
                        "coverage-type":
                          coverageResource["resource"]["type"]["coding"][0][
                          "code"
                          ],
                        class: Class,
                        paymentDetails,
                      });
                    }
                    insurance.push({
                      id: i + 1,
                      insuranceSiteEligibility,
                      Inforce: insuranceInfo[i]["inforce"],
                      items,
                      coverage,
                    });
                    this.setState({ insurance });
                    let requestIdentifier = coverageEligibilityResponse["resource"]["request"][
                      "identifier"
                    ]["system"] + "/" +
                      coverageEligibilityResponse["resource"]["request"][
                      "identifier"
                      ]["value"];
                    let checkEligibilityInfo = {
                      payerId: this.state.InsCompany,
                      servicedStart: this.state.visitDate,
                      servicedEnd: this.state.visitDate,
                      siteEligibility: siteEligibility,
                      responseIdentifier: EligibilityResponseIdentifier,
                      requestIdentifier: requestIdentifier,
                    };
                    this.setState({ checkEligibilityInfo });
                  }
                }
              }
            }
            if (siteEligibility === "not-active") {
              this.setState({
                notActiveFlage: true,
                msgNotActive:
                  "This patient is not eligible,you should select Cash payment!",
              });
            } else {
              this.setState({ notActiveFlage: false, msgNotActive: "" });
            }
          }
          if (
            errorNaphis !=
            "1658-No member found with the supplied patient credentials"
          ) {
            this.setState({ errorNaphis });
          } else {
            this.setState({
              errorNaphies: errorNaphis,
              siteEligibilityFromNaphies: "Not Active",
            });
          }
        } else {
          this.setState({ EligibilityError: error });
          console.log(error, 'ffffffff');
        }
      }
    }
  };

  getAllPatients = async () => {
    let Allpatients = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getPatients",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Allpatients) {
      let { data } = Allpatients;
      if (data) {
        console.log(data, "patientss");
        if (data.success) {
          this.setState({ success: true, allPatients: data.patients });
        } else {
          this.setState({
            success: false,
            error: data.error,
            allPatients: data.patients,
          });
        }
      }
    }
  };
  handleCloseCheck = () => {
    this.setState({
      checkModal: false,
      error: "",
      errorNaphis: "",
      errorNaphies: "",
      EligibilityError: "",
      payment: "",
      TPA: "",
      payerID: "",
      visit: { ...this.state.visit, TPA: "" },
      EligibilityRequestSent: false,
      EligibilityResponse: true,

    });
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "department") {
      let { allDepartments } = this.state;
      if (value) {
        // this.setState({ deptSelected: true });
        // this.getAllDoctorsByDepartmentID(value);
        this.setState({ visit: { ...this.state.visit, [name]: value } });
      } else {
        this.setState({ deptSelected: false });
      }
    } else if (name === "payment") {
      if (value == "insurance") {
        this.setState({
          checkModal: true,
          error: "",
          eligibleInfoView: false,
          errorNaphis: "",
          errorNaphies: "",
          EligibilityError: ""
        });
      } else {
        this.setState({ checkModal: false, insuranceInfo: [] });
      }
      this.setState({ visit: { ...this.state.visit, [name]: value }, [name]: value });
    } else {
      if (name == "InsCompany") {

        this.setState({
          visit: { ...this.state.visit, payerID: value, payerName: allInsuraceCompanies[[value]] },
          payerID: value,
          error: "",
          errorNaphis: "",
          errorNaphies: "",
          EligibilityError: "",
          insurance: [],
          checkEligibilityInfo: {},
          msgNotActive: "",
          eligibleInfoView: false,
          siteEligibility: "",
          payerName: allInsuraceCompanies[[value]],

        });

        // this.setState({
        //   visit: {
        //     ...this.state.visit,
        //     payerName: allInsuraceCompanies[[value]],
        //   },
        //   payerName: allInsuraceCompanies[[value]],
        // });
      } else if (name === "tpa") {
        // TPA: value === "0"?"":value
        this.setState({
          visit: { ...this.state.visit, TPA: value === "0" ? "" : value },
          TPA: value === "0" ? "" : value,
          error: "",
          errorNaphis: "",
          errorNaphies: "",
          EligibilityError: "",
          insurance: [],
          checkEligibilityInfo: {},
          msgNotActive: "",
          eligibleInfoView: false,
          siteEligibility: "",

        })
      } else {
        this.setState({
          visit: { ...this.state.visit, [name]: value },
          [name]: value,
        });
      }
    }
  };
  // HandleDateChange = (e) => {
  //   let date = moment(e.value.$d).format("YYYY-MM-DD");
  //   this.setState({ [e.name]: date });
  // };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "transfer") {
      if (e.target.checked) {
        this.setState({ transferValue: true });
      } else {
        this.setState({ transferValue: false });
      }
    } else if (e.target.name == "newBorn") {
      if (e.target.checked) {
        this.setState({ newbornValue: true });
      } else {
        this.setState({ newbornValue: false });
      }
    }
  };
  handleRegistration = async (e) => {
    e.preventDefault();
    this.setState({ visitRequestSent: true, visitResponse: false });
    let { insuranceInfo } = this.state;
    let flag;
    if (this.state.visit.payment === "insurance" && insuranceInfo.length > 0) {
      flag = true;
    } else if (
      this.state.visit.payment === "insurance" &&
      insuranceInfo.length == 0
    ) {
      flag = false;
      this.setState({
        errorMsg:
          "You did not select the policy, please repeat the payment selection or change it to cash",
      });
    } else if (this.state.visit.payment === "cash") {
      flag = true;
    }

    if (flag) {
      let result = await axios.post(
        KayanURL + "api/KSA/RCM/patient/addNewVisit",
        {
          visit: this.state.visit,
          visitDate: this.state.visitDate,
          transfer: this.state.transferValue,
          newborn: this.state.newbornValue,
          checkEligibilityInfo: this.state.checkEligibilityInfo
            ? this.state.checkEligibilityInfo
            : {},
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );
      if (result) {
        this.setState({ visitRequestSent: false, visitResponse: true });
        let { data } = result;
        if (data) {
          if (data.success) {
            this.setState({ visitAddedSuccess: true });
            this.props.backToRegistrationScreen();
          } else {
            this.setState({ visitAddedSuccess: false, visitError: data.error });
          }
        }
      }
    }
  };

  showTOB = async (items, headers) => {
    console.log("items", items);
    console.log("headers", headers);

    let rowsTOB = items.map((item, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["benefitType"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["allowedMoney"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["category"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["description"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["name"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["network"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["term"]}
          </TableCell>

          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["unit"]}
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ showTOBModal: true, items, headers, rowsTOB });
  };
  showCoverage = async (coverage) => {
    if (coverage && coverage.length > 0) {
      this.setState({
        showCoverageInfo: true,
        memberid: coverage[0].memberid,
        network: coverage[0].network,
        coverageType: coverage[0]["coverage-type"],
        term: coverage[0].period ? coverage[0].period.start + " to " + coverage[0].period.end : "none",
        subscriberRelationship: coverage[0]["subscriber-relationship"],
        costToBeneficiaryTypesValues: coverage[0].paymentDetails,
      });
      let classRows;
      if (coverage[0].class && coverage[0].class.length > 0) {
        classRows = coverage[0].class.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.name}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.value}
              </TableCell>
            </TableRow>
          );
        });
        this.setState({ classRows });
      }
    }
  };
  handleCloseCoverageInfoModal = () => {
    this.setState({ showCoverageInfo: false });
  };

  handleCloseTOBModal = () => {
    this.setState({ showTOBModal: false });
  };

  getAllDepartments = async () => {
    /*  let AllDepartments = await axios.put(
      KayanURL + "api/KSA/RCM/admin/getAllDepartment",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token")

      }
    );
    if (AllDepartments) {
      let { data } = AllDepartments;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allDepartments: data.data.departments});
        } else {
          this.setState({ success: false, error: data.error, allDepartments: data.data.departments});
        }
      }
    } */

    console.log(this.props);

    this.setState({ allDepartments: this.props.AllDepartments });
  };
  getAllDoctors = async () => {
    let AllDoctors = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getAllDoctors",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        role: "doctor",
      }
    );
    if (AllDoctors) {
      console.log(AllDoctors, "doctors");
      let { data } = AllDoctors;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allDoctors: data.doctors });
        } else {
          this.setState({
            success: false,
            error: data.error,
            // allDoctors: data.doctor,
          });
        }
      }
    }
  };
  handleCheckBox = async (e, index) => {
    let { insuranceInfo, insurance } = this.state;
    if (e.target.checked) {
      insuranceInfo.push(insurance[index]);
      this.setState({ insuranceMsg: "" });
    } else {
      let i = insuranceInfo.indexOf(insurance[index]);
      insuranceInfo.splice(i, 1);
    }
  };
  render() {
    let {
      requestSent,
      response,
      error,
      purpose,
      insurance,
      costToBeneficiaryTypesValues,
      classRows,
      allDepartments,
      allDoctors,
    } = this.state;
    console.log(this.state.visit, 'visit')
    // let departmentRows;
    // if (allDepartments && allDepartments.length > 0) {
    //   departmentRows = allDepartments.map((element, index) => {
    //     return (
    //       <option key={index} value={element.id} style={{ fontSize: "small" }}>
    //         {element.name}
    //       </option>
    //     );
    //   });
    // }
    let doctorRows;
    if (allDoctors && allDoctors.length > 0) {
      doctorRows = allDoctors.map((element, index) => {
        return (
          <option key={index} value={element.id} style={{ fontSize: "small" }}>
            {element.name}
          </option>
        );
      });
    }
    let itemHeader = [
      { label: "Benefit Type", key: "benefitType" },
      { label: "Allowed Money", key: "allowedMoney" },
      { label: "Category", key: "category" },
      { label: "Description", key: "description" },
      { label: "Name", key: "name" },
      { label: "Network", key: "network" },
      { label: "Term", key: "term" },
      { label: "Unit", key: "unit" },
    ];

    let TableOfBenefits = [];
    let arr = [];
    let itemsOfIns;
    if (insurance && insurance.length > 0) {
      TableOfBenefits = insurance.map((ins, index) => {
        /*    console.log("ins");
        console.log(ins); */
        itemsOfIns = ins.items;
        let insItems = [];
        if (itemsOfIns && itemsOfIns.length > 0) {
          /*  for (let i = 0; i < itemsOfIns.length; i++) {
            insItems.push({
              benefitType: itemsOfIns[i].benefitType,
              allowedMoney: itemsOfIns[i].allowedMoney,
              category: itemsOfIns[i].category,
              description: itemsOfIns[i].description,
              name: itemsOfIns[i].name,
              network: itemsOfIns[i].network,
              term: itemsOfIns[i].term,
              unit: itemsOfIns[i].unit,
            });
          } */
          // arr.push(itemsOfIns);
        }

        /* console.log("insItems", insItems);

        console.log("itemsOfIns", itemsOfIns);

        console.log("arr", arr); */

        let id = index + 1;
        let siteEligibility = ins.insuranceSiteEligibility;
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <Checkbox
                name="online"
                onChange={(e) => this.handleCheckBox(e, index)}
              />
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {id}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
              {siteEligibility}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {ins.Inforce ? "True" : "False"}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                onClick={(e) => {
                  this.showCoverage(ins["coverage"]);
                }}
                style={{ cursor: "pointer" }}
              >
                <VisibilityIcon style={{ color: "#6262e7" }} />
              </a>
            </TableCell>
            {itemsOfIns && itemsOfIns.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                <CSVLink
                  filename="report.csv"
                  data={itemsOfIns}
                  headers={itemHeader}
                >
                  <FileDownloadIcon />
                </CSVLink>

                <a
                  onClick={(e) => {
                    this.showTOB(itemsOfIns, itemHeader);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <VisibilityIcon style={{ color: "#6262e7" }} />
                </a>
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }
    let costRows;
    if (
      costToBeneficiaryTypesValues &&
      costToBeneficiaryTypesValues.length > 0
    ) {
      costRows = costToBeneficiaryTypesValues.map((element, index) => {
        let keyOfElement = Object.keys(element)[0];
        return (
          <Typography
            id="modal-modal-title"
            key={index}
            sx={{ mt: 2 }}
            style={{ textTransform: "capitalize" }}
          >
            {keyOfElement} : {element[[keyOfElement]]}
          </Typography>
        );
      });
    }
    return (
      <>
        <div style={{ paddingTop: "20px" }}>
          <FormControl style={{ width: "100%" }}>
            <Container>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Visit Date *</Form.Label>
                    <Form.Control
                      type="date"
                      name="visitDate"
                      onChange={this.HandleInputTextChange}
                      defaultValue={this.state.visitDate}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Payment *</Form.Label>
                    <Form.Select
                      onChange={this.HandleInputTextChange}
                      value={this.state.payment ? this.state.payment : ""}
                      required
                      name="payment"
                    >
                      <option value="0">select...</option>
                      <option value="insurance">Insurance</option>
                      <option value="cash">Cash</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Visit Type *</Form.Label>
                    <Form.Select
                      onChange={this.HandleInputTextChange}
                      required
                      name="visitType"
                    >
                      <option value="0">select...</option>
                      <option value="new-visit">New Visit</option>
                      <option value="follow-up">Follow Up</option>
                      <option value="walk-in">Walk In</option>
                      <option value="referral">Referral</option>
                      <option value="refill">Refill</option>
                    </Form.Select>
                  </Form.Group>

                  <div
                    style={{
                      textAlign: "center",
                      padding: "5px 0",
                      display: "flex",
                      marginTop: "50px",
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      label="Transfer"
                      name="transfer"
                      onChange={(e) => this.handleCheckBoxChange(e)}
                      style={{ marginRight: "10px" }}
                    />
                    <Form.Check
                      type="checkbox"
                      label="New Born"
                      name="newBorn"
                      onChange={(e) => this.handleCheckBoxChange(e)}
                    />
                  </div>

                  <Button
                    variant="primary"
                    type="submit"
                    onClick={(e) => this.handleRegistration(e)}
                    style={{
                      width: "100%",
                      marginTop: "30px",
                      backgroundColor: "rgb(97 110 120",
                      border: "1px solid rgb(97 110 120",
                    }}
                  >
                    Add
                  </Button>
                </Col>

                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Doctor *</Form.Label>
                    <Form.Select
                      onChange={this.HandleInputTextChange}
                      required
                      name="doctor"
                    >
                      <option value="0">select...</option>
                      {doctorRows}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              {this.state.visitRequestSent && !this.state.visitResponse ? (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Spinner animation="border" variant="success" />
                </div>
              ) : this.state.visitResponse && this.state.visitError ? (
                <h5 style={{ color: "red" }}>{this.state.visitError}</h5>
              ) : null}
              {this.state.insuranceInfo.length == 0 &&
                this.state.visit.payment === "insurance" ? (
                <div style={{ textAlign: "center" }}>
                  <span style={{ color: "red" }}>{this.state.errorMsg}</span>
                </div>
              ) : null}
            </Container>
          </FormControl>
          {this.state.checkModal ? (
            <>
              <Modal
                open={this.state.checkModal}
                onClose={this.handleCloseCheck}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={style}
                  style={{
                    width: this.state.eligibleInfoView ? "60%" : null,
                    height: this.state.eligibleInfoView ? "650px" : null,
                    overflowY: this.state.eligibleInfoView ? "scroll" : null,
                  }}
                >
                  <div
                    style={{
                      width: this.state.eligibleInfoView ? "50%" : null,
                      margin: "auto",
                    }}
                  >
                    <FormControl sx={{ ml: 3, mb: 3, width: "80%" }}>
                      <InputLabel id="insurance" style={{ fontSize: "small" }}>
                        TPA
                      </InputLabel>
                      <Select
                        required
                        labelId="tpa"
                        name="tpa"
                        label="TPA"
                        onChange={this.HandleInputTextChange}
                        style={{ height: "45px" }}
                      >
                        <MenuItem
                          value="0"
                          style={{ fontSize: "small" }}
                        >
                          Select ...
                        </MenuItem>
                        <MenuItem
                          value="7001463160"
                          name="GlobeMed"
                          style={{ fontSize: "small" }}
                        >
                          GlobeMed Saudi
                        </MenuItem>
                        <MenuItem
                          value="7001604342"
                          name="Mednet"
                          style={{ fontSize: "small" }}
                        >
                          Mednet
                        </MenuItem>

                        <MenuItem
                          value="7001599658"
                          name="Totalcare"
                          style={{ fontSize: "small" }}
                        >
                          Totalcare
                        </MenuItem>
                        <MenuItem
                          value="7001580856"
                          name="Nextcare"
                          style={{ fontSize: "small" }}
                        >
                          Nextcare
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ ml: 3, mb: 3, width: "80%" }}>
                      <InputLabel id="insurance" style={{ fontSize: "small" }}>
                        Insurance Company
                      </InputLabel>
                      <Select
                        required
                        labelId="insurance"
                        name="InsCompany"
                        label="Insurance Company"
                        onChange={this.HandleInputTextChange}
                        style={{ height: "45px" }}
                      >
                        {this.state.TPA === "7001580856" ? (
                          netxCareInsurance.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                name="Pseudo Payer"
                                style={{ fontSize: "small" }}
                              >
                                {ele.name}
                              </MenuItem>
                            )

                          })

                        ) : this.state.TPA === "7001599658" ? (
                          totalCareInsurance.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                name="Pseudo Payer"
                                style={{ fontSize: "small" }}
                              >
                                {ele.name}
                              </MenuItem>
                            )

                          })

                        ) : this.state.TPA === "7001604342" ? (
                          medNetInsurance.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                name="Pseudo Payer"
                                style={{ fontSize: "small" }}
                              >
                                {ele.name}
                              </MenuItem>
                            )

                          })

                        ) : this.state.TPA === "7001463160" ? (
                          globMedInsurance.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                name="Pseudo Payer"
                                style={{ fontSize: "small" }}
                              >
                                {ele.name}
                              </MenuItem>
                            )

                          })

                        ) : (
                          nonTpa.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.value}
                                name="Pseudo Payer"
                                style={{ fontSize: "small" }}
                              >
                                {ele.name}
                              </MenuItem>
                            )

                          })
                        )}

                      </Select>
                    </FormControl>


                    <div style={{ textAlign: "center" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          width: "200px",
                          color: "white",
                        }}
                        onClick={(e) => this.handleCheckEligibility(e)}
                      >
                        Check Eligibility{" "}
                      </Button>
                      {this.state.EligibilityError ? (
                        <h6 style={{ textAlign: "center", color: "red" }}>{this.state.EligibilityError}</h6>
                      ) : null}
                    </div>
                  </div>
                  {this.state.EligibilityRequestSent &&
                    !this.state.EligibilityResponse ? (
                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                      <Spinner animation="border" variant="success" />
                    </div>
                  ) : null}
                  {this.state.errorNaphis ? (
                    <div style={{ marginTop: "10px" }}>
                      {this.state.siteEligibilityFromNaphies ? (
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{
                            textAlign: "center",
                            marginBottom: "5px",
                            fontSize: "14px",
                          }}
                        >
                          This Patient is{" "}
                          {this.state.siteEligibilityFromNaphies}
                        </Typography>
                      ) : null}

                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{
                          textAlign: "center",
                          marginBottom: "5px",
                          fontSize: "14px",
                          color: "red",
                        }}
                      >
                        {this.state.errorNaphis}
                      </Typography>
                    </div>
                  ) : !this.state.success ? (
                    <div style={{ marginTop: "10px" }}>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{
                          textAlign: "center",
                          marginBottom: "5px",
                          fontSize: "14px",
                          color: "red",
                        }}
                      >
                        {this.state.error}
                      </Typography>
                    </div>
                  ) : null}
                  {this.state.eligibleInfoView ? (
                    <div
                      style={{
                        padding: "10px",
                        boxShadow:
                          "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                        borderRadius: "15px",
                        marginTop: "20px",
                      }}
                    >
                      <div
                        style={
                          {
                            /*  width: "48%", */
                            /* backgroundColor: "#a59f9f", */
                            /*   margin: "auto", */
                            /*  borderRadius: "24px", */
                            /*   padding: "15px", */
                          }
                        }
                      >
                        <Typography
                          id="modal-modal-description"
                          sx={{ mt: 2 }}
                          style={{ textTransform: "capitalize" }}
                        >
                          Site Eligibility:{" "}
                          {this.state.notActiveFlage
                            ? this.state.msgNotActive
                            : this.state.siteEligibility}
                        </Typography>
                        {/*  {!this.state.notActiveFlage ? (
                          <Typography
                            id="modal-modal-description"
                            sx={{ mt: 2 }}
                          >
                            Period: From {this.state.startDate} To{" "}
                            {this.state.endDate}
                          </Typography>
                        ) : null} */}
                      </div>
                      {insurance && insurance.length > 0 ? (
                        <>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ mt: 2 }}
                            style={{ textAlign: "center" }}
                          >
                            Active Policies
                          </Typography>
                          <TableContainer
                            component={Paper}
                            style={{ marginTop: "20px" }}
                          >
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center"></TableCell>
                                  <TableCell align="center">ID</TableCell>
                                  <TableCell align="center">
                                    Site Eligibility
                                  </TableCell>
                                  <TableCell align="center">Inforce</TableCell>
                                  <TableCell align="center">Coverage</TableCell>
                                  {itemsOfIns && itemsOfIns.length > 0 ? (
                                    <TableCell align="center">TOB</TableCell>
                                  ) : null}
                                </TableRow>
                              </TableHead>
                              <TableBody>{TableOfBenefits}</TableBody>
                            </Table>
                          </TableContainer>
                          <div style={{ textAlign: "center" }}>
                            <span style={{ color: "red", fontSize: "11px" }}>
                              {this.state.insuranceMsg}
                            </span>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                                color: "white",
                                marginTop: "10px",
                              }}
                              onClick={(e) => this.handleSave(e)}
                            >
                              Save{" "}
                            </Button>
                          </div>
                        </>
                      ) : null}
                    </div>
                  ) : null}
                </Box>
              </Modal>
            </>
          ) : null}
          {this.state.showCoverageInfo ? (
            <>
              <Modal
                open={this.state.showCoverageInfo}
                onClose={this.handleCloseCoverageInfoModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={style}
                  style={{ width: "70%", height: "70%", overflowY: "scroll" }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ textAlign: "center" }}
                  >
                    Coverage Information
                  </Typography>
                  <Typography id="modal-modal-title" sx={{ mt: 2 }}>
                    Member ID:{this.state.memberid}
                  </Typography>
                  <Typography
                    id="modal-modal-title"
                    sx={{ mt: 2 }}
                    style={{ textTransform: "capitalize" }}
                  >
                    Coverage Type:{this.state.coverageType}
                  </Typography>
                  <Typography
                    id="modal-modal-title"
                    sx={{ mt: 2 }}
                    style={{ textTransform: "capitalize" }}
                  >
                    Network:{this.state.network}
                  </Typography>
                  <Typography
                    id="modal-modal-title"
                    sx={{ mt: 2 }}
                    style={{ textTransform: "capitalize" }}
                  >
                    Term:{this.state.term}
                  </Typography>
                  <Typography
                    id="modal-modal-title"
                    sx={{ mt: 2 }}
                    style={{ textTransform: "capitalize" }}
                  >
                    subscriber Relationship:{this.state.subscriberRelationship}
                  </Typography>
                  {this.state.costToBeneficiaryTypesValues &&
                    this.state.costToBeneficiaryTypesValues.length > 0 ? (
                    <>{costRows}</>
                  ) : null}
                  <Typography
                    id="modal-modal-title"
                    sx={{ mt: 2 }}
                    style={{ textTransform: "capitalize", textAlign: "center" }}
                  >
                    Classes
                  </Typography>
                  <TableContainer
                    component={Paper}
                    style={{ marginTop: "20px" }}
                  >
                    <Table sx={{ minWidth: 100 }} aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: "center" }}>
                          <TableCell align="center">Type</TableCell>
                          <TableCell align="center">Name</TableCell>
                          <TableCell align="center">Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>{classRows}</TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Modal>
            </>
          ) : null}

          {this.state.showTOBModal ? (
            <>
              <Modal
                open={this.state.showTOBModal}
                onClose={this.handleCloseTOBModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={style}
                  style={{
                    width: "70%",
                    height: "70%",
                    overflowY: "scroll",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ textAlign: "center" }}
                  >
                    TOB
                  </Typography>

                  {
                    <TableContainer
                      component={Paper}
                      style={{ marginTop: "20px" }}
                    >
                      <Table sx={{ minWidth: 100 }} aria-label="simple table">
                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                          <TableRow style={{ textAlign: "center" }}>
                            {this.state.headers.map((head) => {
                              console.log("head", head);
                              return (
                                <TableCell align="center">
                                  {head.label}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>{this.state.rowsTOB}</TableBody>
                      </Table>
                    </TableContainer>
                  }
                </Box>
              </Modal>
            </>
          ) : null}
        </div>
      </>
    );
  }
}

export default VisitRegisteration;
